@if (isDsnpAgent) {
  <div class='quick-link'>
    <a href="javascript:void(0)" (click)="submitForm();" class="external-link">
      {{ label || 'Cavulus' }}
      <span class="material-symbols-outlined">open_in_new</span>
    </a>
  </div>
}